import React from 'react';
import { Button } from 'baseui/button';
import Cookies from 'js-cookie';
import { COOKIE_NAMES } from '@gtintel/platform-constants';
export const ReportBuilderMagicLink = ({
  projectId,
  disabled = false,
  sendToken = false
}) => {
  const handleClick = async () => {
    // The magic link endpoint will handle the redirect automatically
    const currentUrl = window.location.href;
    window.location.href = `${process.env.API_URL}report-builder/magic-link/${projectId}?returnUrl=${encodeURIComponent(currentUrl)}${sendToken ? `&token=${encodeURIComponent(Cookies.get(COOKIE_NAMES.TOKEN))}` : ''}`;
  };
  if (disabled) {
    return <Button disabled>Go to Report Builder</Button>;
  }
  return <Button onClick={handleClick}>Go to Report Builder</Button>;
};
export default ReportBuilderMagicLink;